// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4609":"33d132e9","8357":"33d132e9"}[chunkId] + ".chunk.css";
};